// global components registration
// Vue.component('contact-form', require('../modules/contact/components/ContactForm.vue').default);

// modular imports, please do not change or remove this line
Vue.component('banner', require('../modules/banner/components/Banner.vue').default);
Vue.component('search-form', require('../modules/product-search/components/SearchForm.vue').default);
Vue.component('newsletter-form', require('../modules/newsletter/components/NewsletterForm.vue').default);
Vue.component('product-image', require('../modules/product-image/components/Images.vue').default);
Vue.component('buy-button', require('../modules/product-buy-button/components/BuyButton.vue').default);
Vue.component('contact-form', require('../modules/contact/components/ContactForm.vue').default);
Vue.component('cart', require('../modules/cart/components/Cart.vue').default);

//assistance
Vue.component(
  'assistance-new-customer',
  require('../modules/assistance-new-customer/components/NewCustomerForm.vue').default
);

Vue.component(
  'assistance-login-form',
  require('../modules/login/components/LoginForm.vue').default
);
